import { render } from "./KazaviaspasCompany.vue?vue&type=template&id=ee0a819c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__